import * as wjcGrid from '@grapecity/wijmo.grid';
import { CellType, DataMap } from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridCellTemplate, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import '@grapecity/wijmo.styles/wijmo.css';
import TextComponent from 'components/Input/TextComponent';
import SelectComponent from 'components/Input/SelectComponent';
import IconButtonCompnent from 'components/Input/IconButtonCompnent';
import { MessageModal } from 'components/modal/MessageModal';
import { ToastMessage } from 'components/modal/ToastMessage';
import ApprovalRejectModal from 'views/Approval/ApprovalRejectModal';
import { useMaster } from 'context/MasterContext';
import { useRestApi } from 'context/RestApiContext';
import { useAuth } from 'context/AuthContext';
import { format } from 'date-fns';
import { useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router';
import { Label } from 'reactstrap';
import { numberToLetters } from 'utils/numberUtils';
import QuoteBaseModal from 'views/CustomerQuoteEntry/QuoteBaseModal';
import StatusLableComponent from 'components/Input/StatusLableComponent';
import { toFloat, toInt, calcTax } from 'utils/numberUtils';
import { KoujihiPersent, KoujiKbn2Type } from 'constants/constants';
import { useApprovalRejectCommentModal } from 'views/Approval/ApprovalRejectCommentModalContext';
import EditIcon from '@mui/icons-material/Edit';
import { Typography, Stack } from '@mui/material';
import './CustomerQuoteEntry.css';
import { QuoteFormatTypes } from 'constants/constants';
import QuoteCopyModal from 'views/CustomerQuoteEntry/QuoteCopyModal';

function CustomerQuoteEntry() {
  const restApi = useRestApi();
  // 画面パラメタを取得
  const location = useLocation();
  // 履歴
  const navigate = useNavigate();
  // マスタ情報
  const master = useMaster();
  // 権限情報
  const auth = useAuth();
  // トースト表示
  const [toast, setToast] = useState({});
  // 却下コメントモーダル
  const approvalRejectCommentModal = useApprovalRejectCommentModal();
  // グリッド
  const flexGrid = useRef();

  // 見積コピーモーダル表示
  const [showCopyModal, setShowCopyModal] = useState(false);

  // 顧客情報
  const [client, setClient] = useState({
    CLIENT_CD: '',
    NAME_SEI_1: '',
    NAME_MEI_1: '',
  });

  // 編集中か？
  const [edited, setEdited] = useState(false);

  const handlePopstate = () => {
    const isDiscardedOK = confirm('保存されていないデータは削除されますが、よろしいですか？');
    if (isDiscardedOK) {
      // OKの場合、historyAPIで戻るを実行します。
      window.history.back();
      setEdited(false);
    } else {
      // キャンセルの場合、 ダミー履歴を挿入して「戻る」を1回分吸収できる状態にする
      history.pushState(null, '', null);
    }
  };

  useEffect(() => {
    // Stateに編集中フラグを設定
    const newState = {
      ...location.state,
      edited: edited,
    };
    navigate(location.pathname, { state: newState });

    const handleBeforeUnload = (event) => {
      if (edited) {
        event.preventDefault();
        event.returnValue = '変更が保存されていません。本当にページを離れますか？';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    if (edited) {
      // ダミー履歴を挿入して「戻る」を1回分吸収できる状態にする
      history.pushState(null, '', null);
      window.addEventListener('popstate', handlePopstate, false);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload, false);
      window.removeEventListener('popstate', handlePopstate, false);
    };
  }, [edited]);

  // 工事費パーセントマッピング
  const koujihiPersentMap = new DataMap(KoujihiPersent, 'id', 'name');

  // 工事情報
  const [constraction, setConstraction] = useState({});

  // 小工事の基準
  const [minorConstructionCriteria, setMinorConstructionCriteria] = useState({});

  // ボタンのアクション
  const action = {
    '': { caption: '', cmd: '', variant: '', readOnly: false },
    add: { caption: '登録', cmd: 'add', variant: 'primary', readOnly: false }, // 新規登録
    upd: { caption: '更新', cmd: 'upd', variant: 'primary', readOnly: false }, // 編集
    del: { caption: '削除', cmd: 'del', variant: 'danger', readOnly: true }, // 削除
    cpy: { caption: '登録', cmd: 'add', variant: 'primary', readOnly: false }, // コピー
    los: { caption: '失注', cmd: 'upd', variant: 'danger', readOnly: false }, // 失注
    approval: { caption: '承認', cmd: 'upd', variant: 'primary', readOnly: true }, // 承認
    request: { caption: '承認申請', cmd: 'upd', variant: 'primary', readOnly: false }, // 承認申請
    cancel: { caption: '申請取消', cmd: 'upd', variant: 'danger', readOnly: true }, // 申請取消
  };
  // モード
  const [mode, setMode] = useState('');

  // 確認ダイアログ
  const [dialog, setDialog] = useState({});
  // 承認却下モーダルパラメタ
  const [approvalRejectModalParam, setApprovalRejectModalParam] = useState({});

  // 戻り先
  const [backPage, setBackPage] = useState();

  // 工事情報を表示するか？
  const [displayInfo, setDisplayInfo] = useState(true);

  // 集計行のマージ処理
  class CustomMergeManager extends wjcGrid.MergeManager {
    getMergedRange(panel, r, c, clip = true) {
      var rng = new wjcGrid.CellRange(r, c);
      let dataItem = panel?.grid?.rows[r]?.dataItem;
      if (panel.cellType == CellType.Cell && dataItem && dataItem['Group']) {
        if (c >= 1 && c < 4) {
          rng.col = 1;
          rng.col2 = 5;
          return rng;
        }
        if (c > 6 && c < 9) {
          rng.col = 7;
          rng.col2 = 9;
          return rng;
        }
      }
      return null;
    }
  }

  // モーダルを表示・非表示
  const [show, setShow] = useState(false);

  // 明細登録モーダルへのパラメタ
  const [paramBaseQuote, setParamBaseQuote] = useState({});

  // 工事見積ヘッダ
  const [quoteHeader, setQuoteHeader] = useState({
    STATUS: '',
    MINOR_CONSTRUCTION_FLG: 0,
    QUOTE_FORMAT_TYPE: 1,
    KOUJI_MEI: '',
    KOUJI_BASYO: '',
    NEBIKI_HEADER: '特別割引',
    KOUKI: '別途お打合せ',
    MITSU_DATE: format(new Date(), 'yyyy/MM/dd'),
    MITSU_KIGEN: '見積日より３０日間',
    ZUMEN_NO: '',
    BIKO: '特になし',
    TAN_CD: auth.auth.user_id,
    BIKO_SYANAI: '',
  });

  // 工事見積区分データ
  const [quoteKbns, setQuoteKbns] = useState([]);

  // 工事見積明細データ
  const [quoteDetails, setQuoteDetails] = useState([]);

  // 工事見積明細集計データ
  const [quoteTotal, setQuoteTotal] = useState([{ Nebiki: 0 }]);

  // 工事見積明細データ（表示用）
  const [viewQuoteDetails, setViewQuoteDetails] = useState([]);

  // マウスホバー中の項目
  const [hoverItem, setHoverItem] = useState(-1);

  // 追加請求かどうか？
  const [isAddInvoice, setAddInvoice] = useState(location?.state?.addInvoice);

  // 登録・コピーの場合、一時保存カウント
  const [tempCount, setTempCount] = useState(0);

  // Grid初期化処理
  const initializedGrid = (flex) => {
    flex.mergeManager = new CustomMergeManager();
  };

  // 初期表示
  useEffect(() => {
    let seikyuNo = location?.state?.seikyuNo;
    let quoteNo = location?.state?.quoteNo;

    // 編集中を解除
    setEdited(false);
    // 処理モード
    setMode(location?.state?.mode);
    // 戻り先
    setBackPage(location?.state?.backPage);

    // 空行を登録(見た目のため)
    setViewQuoteDetails([...Array(13).map((_) => { })]);

    //小工事の基準を取得
    restApi.get('/api/quote/criteria', (data) => {
      setMinorConstructionCriteria(data);
    });

    if (location?.state?.mode == 'add') {
      // 新規追加モードの場合は、工事場所に住所を設定
      restApi.get(`/api/construction/${seikyuNo}`, (data) => {
        // 顧客情報
        setClient(data.client);
        // 工事情報
        setConstraction(data.construction);
        // 見積情報
        setQuoteHeader({
          ...quoteHeader,
          KOUJI_BASYO: data.client.PREF + data.client.CITY + data.client.TOWN + data.client.ADDRESS,
        });
        setAddInvoice(location?.state?.addInvoice);
      });
    } else {
      // 新規追加モード以外はDBから見積もり情報を取得する
      restApi.get(`/api/quote/${quoteNo}`, (data) => {
        // コピーの場合は新規になるのでキーを削除
        if (location?.state?.mode == 'cpy') {
          delete data.headar.QUOTE_NO;
          data.headar.MITSU_DATE = format(new Date(), 'yyyy/MM/dd');
          data.headar.KOUKI = '';
        }
        setQuoteHeader(data.headar);
        setQuoteKbns(data.kbns);
        setQuoteTotal([
          {
            Nebiki: data.headar.NEBIKI,
          },
        ]);
        setQuoteDetails(data.details);
        setClient(data.client);
        setConstraction(data.constraction);
        setAddInvoice(data.headar.MOTO_KEI_NO == 1);
      });
    }
  }, []);

  // 明細登録ボタン押下処理
  const handleOnClickDetailRegist = () => {
    // 見積基盤モーダルにパラメタを渡す
    setParamBaseQuote({
      Mode: 'add',
      KojiSyu: [], // 登録済みの工事種別
      QUOTE_KNO: quoteKbns.length + 1, // 見積区分番号
      Details: [],
      isAddInvoice: isAddInvoice,
      shokei: quoteDetails.reduce((a, x) => a + x['KINGAKU'], 0),
      koujihi: quoteDetails // 工事費（タイプが1:通常と2:運搬費の金額の合計）
        .filter((x) => x['KOUJI_TYPE'] == 1 || x['KOUJI_TYPE'] == 2)
        .reduce((a, x) => a + x['KINGAKU'], 0),
      genkaKei: quoteDetails.reduce((a, x) => a + x['GENKA_KINGAKU'], 0),
      nebiki: quoteTotal[0].Nebiki,
      otherQuoteDetails: quoteDetails, // 登録済みの明細データ
    });
    setShow(true);
  };

  // 明細編集ボタン押下処理
  const handleOnClickDetailEdit = (item) => (e) => {
    // 計算対象の明細（参考価格の工事明細を除いた明細）を取得
    const calcQuoteDetails = getCalcQuoteDetails();

    // 見積基盤モーダルにパラメタを渡す
    setParamBaseQuote({
      Mode: 'edit',
      KojiSyu: [],
      TargetKojiSyu: item['KOUJI_SYU'],
      quoteKbn: quoteKbns.find((x) => x.QUOTE_KNO == item.QUOTE_KNO),
      Details: quoteDetails.filter((x) => x.QUOTE_KNO == item.QUOTE_KNO), // 対象の工事種の明細情報
      isAddInvoice: isAddInvoice,
      shokei: calcQuoteDetails
        .filter((x) => x.QUOTE_KNO != item.QUOTE_KNO)
        .reduce((a, x) => a + x['KINGAKU'], 0),
      koujihi: calcQuoteDetails // 工事費（タイプが1:通常と2:運搬費の金額の合計）
        .filter(
          (x) => x.QUOTE_KNO != item.QUOTE_KNO && (x['KOUJI_TYPE'] == 1 || x['KOUJI_TYPE'] == 2)
        )
        .reduce((a, x) => a + x['KINGAKU'], 0),
      nebiki: quoteTotal[0].Nebiki,
      genkaKei: calcQuoteDetails
        .filter((x) => x.QUOTE_KNO != item.QUOTE_KNO)
        .reduce((a, x) => a + x['GENKA_KINGAKU'], 0),
      otherQuoteDetails: calcQuoteDetails.filter((x) => x.QUOTE_KNO != item.QUOTE_KNO), // 編集対象以外の明細データ
    });
    setShow(true);
  };
  // 明細移動ボタン押下処理
  const handleOnClickDetailMove = (item, upDown) => (e) => {
    // 下に移動
    if (upDown == 'down') {
      // 明細区分を下に移動
      setQuoteKbns(
        quoteKbns.map((x) =>
          x.QUOTE_KNO == item.QUOTE_KNO
            ? { ...x, QUOTE_KNO: x.QUOTE_KNO + 1 }
            : x.QUOTE_KNO == item.QUOTE_KNO + 1
              ? { ...x, QUOTE_KNO: x.QUOTE_KNO - 1 }
              : x
        )
      );

      // 明細を下に移動
      setQuoteDetails(
        quoteDetails
          .map((x) =>
            x.QUOTE_KNO == item.QUOTE_KNO
              ? { ...x, QUOTE_KNO: x.QUOTE_KNO + 1 }
              : x.QUOTE_KNO == item.QUOTE_KNO + 1
                ? { ...x, QUOTE_KNO: x.QUOTE_KNO - 1 }
                : x
          )
          .sort((a, b) => a.QUOTE_KNO - b.QUOTE_KNO)
      );
    }
    // 上に移動
    else {
      // 明細区分を下に移動
      setQuoteKbns(
        quoteKbns.map((x) =>
          x.QUOTE_KNO == item.QUOTE_KNO
            ? { ...x, QUOTE_KNO: x.QUOTE_KNO - 1 }
            : x.QUOTE_KNO == item.QUOTE_KNO - 1
              ? { ...x, QUOTE_KNO: x.QUOTE_KNO + 1 }
              : x
        )
      );

      // 明細を下に移動
      setQuoteDetails(
        quoteDetails
          .map((x) =>
            x.QUOTE_KNO == item.QUOTE_KNO
              ? { ...x, QUOTE_KNO: x.QUOTE_KNO - 1 }
              : x.QUOTE_KNO == item.QUOTE_KNO - 1
                ? { ...x, QUOTE_KNO: x.QUOTE_KNO + 1 }
                : x
          )
          .sort((a, b) => a.QUOTE_KNO - b.QUOTE_KNO)
      );
    }
  };
  // 明細削除ボタン押下処理
  const handleOnClickDetailDelete = (item) => (e) => {
    setDialog({
      type: 'confirm',
      message: `${item.CONTENT}を削除します。よろしいですか？`,
      okCallBack: () => {
        // 明細区分を再計算して更新
        let _quoteKbns = quoteKbns
          .filter((x) => x.QUOTE_KNO != item.QUOTE_KNO)
          .map((x) => (x.QUOTE_KNO > item.QUOTE_KNO ? { ...x, QUOTE_KNO: x.QUOTE_KNO - 1 } : x));

        // 対象の工事を削除
        let _quoteDetails = quoteDetails
          .filter((x) => x.QUOTE_KNO != item.QUOTE_KNO)
          .map((x) => (x.QUOTE_KNO > item.QUOTE_KNO ? { ...x, QUOTE_KNO: x.QUOTE_KNO - 1 } : x));

        // 参考価格を除いた工事費を算出
        const refKnos = _quoteKbns.filter((qk) => qk.REFERNCE_PRICE == 1).map((qk) => qk.QUOTE_KNO);
        let koujihi = _quoteDetails
          .filter((x) => !refKnos.includes(x.QUOTE_KNO))
          .filter((x) => x['KOUJI_TYPE'] == 1 || x['KOUJI_TYPE'] == 2)
          .reduce((a, x) => a + toFloat(x['KINGAKU']), 0);

        // 工事費パーセンテージを再計算
        _quoteDetails = _quoteDetails.map((x) => {
          if (x.KOUJI_TYPE != 3 || x.KOUJIHI_PER > 100) {
            return x;
          }
          // 工事費パーセンテージの場合
          // 対象の工事が参考価格だった場合はプラスする
          let targetKujihi = 0;
          if (refKnos.includes(x.QUOTE_KNO)) {
            targetKujihi = _quoteDetails
              .filter((y) => y.QUOTE_KNO == x.QUOTE_KNO)
              .filter((y) => y['KOUJI_TYPE'] == 1 || y['KOUJI_TYPE'] == 2)
              .reduce((a, y) => a + toFloat(y['KINGAKU']), 0);
          }
          const kingaku = toFloat(((koujihi + targetKujihi) * x.KOUJIHI_PER) / 100, 0);
          return {
            ...x,
            TANKA: kingaku,
            KINGAKU: kingaku,
          };
        });
        setQuoteDetails(_quoteDetails);

        // 合計金額を再計算
        _quoteKbns = _quoteKbns.map((k) => {
          const total = _quoteDetails
            .filter((d) => d.QUOTE_KNO == k.QUOTE_KNO)
            .reduce((a, x) => a + toFloat(x['KINGAKU']), 0);
          return { ...k, TANKA: total, TOTAL: total };
        });

        setQuoteKbns(_quoteKbns);

        setEdited(true); // 編集中フラグを立てる
      },
    });
  };

  // 計算対象の明細（参考価格の工事明細を除いた明細）を取得
  const getCalcQuoteDetails = () => {
    // 参考価格の見積区分番号
    const refKnos = quoteKbns.filter((qk) => qk.REFERNCE_PRICE == 1).map((qk) => qk.QUOTE_KNO);

    // 明細から参考価格のものは除く
    return quoteDetails.filter((x) => !refKnos.includes(x.QUOTE_KNO));
  };

  // 明細データに変更があった時の処理
  useEffect(() => {
    let _viewQuoteDetails = [];
    let _quoteKno = '';
    quoteDetails.forEach((qd, i) => {
      // 明細の小計行を作成
      if (_quoteKno != qd.QUOTE_KNO) {
        const qk = quoteKbns.find((x) => x.QUOTE_KNO == qd.QUOTE_KNO);
        _quoteKno = qd.QUOTE_KNO;

        // 合計金額
        const kingaku = quoteDetails
          .filter((x) => x['QUOTE_KNO'] == qd['QUOTE_KNO'])
          .reduce((a, x) => a + x['KINGAKU'], 0);

        _viewQuoteDetails.push({
          Group: true,
          Deletable: !quoteDetails.some((x) => x.QUOTE_KNO == qd.QUOTE_KNO && x.CYU_MNO_KEY), // 注文がない場合は削除可能
          KOUJI_SYU: qd['KOUJI_SYU'],
          QUOTE_KNO: qd.QUOTE_KNO,
          CONTENT: numberToLetters(qd.QUOTE_KNO) + '. ' + qk['KOUJI_DISPLAY_NAME'],
          SIYOU: qk.SIYOU,
          BIKO: qk.BIKO,
          BIKO_COLOR: qk.BIKO_COLOR,
          TANKA: kingaku,
          KINGAKU: qk.REFERNCE_PRICE == 1 ? '別途参考価格' : kingaku,
          GENKA_KINGAKU: quoteDetails
            .filter((x) => x['QUOTE_KNO'] == qd['QUOTE_KNO'])
            .reduce((a, x) => a + x['GENKA_KINGAKU'], 0),
        });
      }
      // 明細を追加
      _viewQuoteDetails.push(qd);
    });

    setViewQuoteDetails([..._viewQuoteDetails]);

    // 計算対象の明細（参考価格の工事明細を除いた明細）を取得
    const calcQuoteDetails = getCalcQuoteDetails();

    // 工事費（タイプが1:通常と2:運搬費の金額の合計）
    let koujihi = calcQuoteDetails
      .filter((x) => x['KOUJI_TYPE'] == 1 || x['KOUJI_TYPE'] == 2)
      .reduce((a, x) => a + x['KINGAKU'], 0);
    // 値引き額
    let nebiki = quoteTotal[0].Nebiki;
    // 小計
    let shokei = calcQuoteDetails.reduce((a, x) => a + x['KINGAKU'], 0);
    // 税別合計
    let zeinuki = shokei + nebiki;
    // 消費税端数処理
    let tax = calcTax(zeinuki);
    // 請求額
    let seikyu = zeinuki + tax;
    // 原価合計
    let genka_kingaku = calcQuoteDetails.reduce((a, x) => a + x['GENKA_KINGAKU'], 0);
    // 粗利
    let arari = zeinuki - genka_kingaku;
    // 粗利率
    let arariritu = arari / zeinuki;

    // 集計結果を反映
    setQuoteTotal([
      {
        Koujihi: koujihi,
        ShoKei: shokei,
        Nebiki: nebiki,
        Zeinuki: zeinuki,
        ZeiKei: tax,
        SeikyuKei: seikyu,
        GenkaKei: genka_kingaku,
        ArariKei: arari,
        RiekiRitsu: !isNaN(arariritu) ? arariritu : 0,
      },
    ]);
  }, [quoteDetails, displayInfo]);

  // 見積明細モーダルからのコールバック処理
  const callbackQuoteDetaiModal = (details, _quoteKbn) => {
    // 編集した見積区分を反映
    let _quoteKbns = [];
    if (quoteKbns.some((x) => x.QUOTE_KNO == _quoteKbn.QUOTE_KNO)) {
      _quoteKbns = quoteKbns.map((x) => (x.QUOTE_KNO == _quoteKbn.QUOTE_KNO ? _quoteKbn : x));
    } else {
      _quoteKbns = [...quoteKbns, _quoteKbn];
    }

    let _quoteDetails = [...quoteDetails];

    // 対象更新対象を置き換え
    _quoteDetails = _quoteDetails.filter((x) => x.QUOTE_KNO != _quoteKbn.QUOTE_KNO);
    _quoteDetails = _quoteDetails.concat(details);

    // 参考価格を除いた工事費を算出
    const refKnos = _quoteKbns.filter((qk) => qk.REFERNCE_PRICE == 1).map((qk) => qk.QUOTE_KNO);
    let koujihi = _quoteDetails
      .filter((x) => !refKnos.includes(x.QUOTE_KNO))
      .filter((x) => x['KOUJI_TYPE'] == 1 || x['KOUJI_TYPE'] == 2)
      .reduce((a, x) => a + toFloat(x['KINGAKU']), 0);

    // 工事費パーセンテージを再計算
    _quoteDetails = _quoteDetails.map((x) => {
      if (x.KOUJI_TYPE != 3 || x.KOUJIHI_PER > 100) {
        return x;
      }
      // 工事費パーセンテージの場合
      // 対象の工事が参考価格だった場合はプラスする
      let targetKujihi = 0;
      if (refKnos.includes(x.QUOTE_KNO)) {
        targetKujihi = _quoteDetails
          .filter((y) => y.QUOTE_KNO == x.QUOTE_KNO)
          .filter((y) => y['KOUJI_TYPE'] == 1 || y['KOUJI_TYPE'] == 2)
          .reduce((a, y) => a + toFloat(y['KINGAKU']), 0);
      }
      const kingaku = toFloat(((koujihi + targetKujihi) * x.KOUJIHI_PER) / 100, 0);
      return {
        ...x,
        TANKA: kingaku,
        KINGAKU: kingaku,
      };
    });

    // 合計金額を再計算
    _quoteKbns = _quoteKbns.map((k) => {
      const total = _quoteDetails
        .filter((d) => d.QUOTE_KNO == k.QUOTE_KNO)
        .reduce((a, x) => a + toFloat(x['KINGAKU']), 0);
      return { ...k, TANKA: total, TOTAL: total };
    });
    setQuoteKbns(_quoteKbns);

    // 見積区分番号の昇順で並べ替え
    setQuoteDetails(_quoteDetails.sort((a, b) => a.QUOTE_KNO - b.QUOTE_KNO));

    setEdited(true); // 編集中フラグを立てる
  };

  // グリッドのフォーマット処理
  const formatItem = (grid, e) => {
    if (e.panel.cellType == CellType.Cell) {
      var col = grid.columns[e.col];
      var dataItem = grid.rows[e.row].dataItem;
      // 集計行の場合
      if (dataItem && dataItem['Group']) {
        e.cell.style.background = isAddInvoice ? 'rgb(63, 130, 243)' : 'rgb(255, 160, 122)'; // 追加請求と見積もりで色を変更
        // 備考の場合はフォントカラーを修正
        if (col.binding == 'BIKO') {
          e.cell.style.color = dataItem.BIKO_COLOR;
        } else {
          e.cell.style.color = 'rgb(255, 255, 255)';
        }
        // 明細行の場合
      } else {
        e.cell.style.background = '';

        // 備考の場合はフォントカラーを修正
        if (col.binding == 'BIKO') {
          e.cell.style.color = dataItem.BIKO_COLOR;
        } else {
          e.cell.style.color = '';
        }
        const hideZeroCols = [
          'SU',
          'TANKA',
          'KINGAKU',
          'GENKA_RATE',
          'GENKA_TANKA',
          'GENKA_KINGAKU'
        ];
        if (hideZeroCols.includes(col.binding)) {
          const val = dataItem[col.binding];
          if (val === 0 || val === '' || val === null || val === undefined) {
            e.cell.textContent = '';
          }
        }
      }
    }
  };

  // 小工事基準チェック
  const checkMinorConstruction = () => {
    if (quoteHeader.MINOR_CONSTRUCTION_FLG == 1 && minorConstructionCriteria < quoteTotal[0].Zeinuki) {
      setDialog({
        type: 'error',
        message:
          '小工事の基準となる金額(' +
          minorConstructionCriteria.toLocaleString() +
          '円)を超えているため、\n「受注済み小工事（見積承認不要）」の✔を外してください。',
      });
      return false;
    }
    return true;
  };

  // 編集処理
  const handleHeaderChange = (prop) => (target) => {
    const originalValue = quoteHeader[prop];
    const inputValue = target?.value ?? target?.target?.value;

    const formattedOriginal = typeof originalValue === 'string'
      ? originalValue.replace(/-/g, '/')
      : originalValue;

    if (formattedOriginal != inputValue) {
      setEdited(true);
    }
    setQuoteHeader({ ...quoteHeader, [prop]: inputValue });
  };

  // 保存処理
  const handleOnClickSave = (_, reject = null) => {
    let _caption = reject ? '却下' : action[mode]['caption'];
    let _cmd = reject ? 'upd' : action[mode]['cmd'];

    // 却下の場合
    if (reject) {
      setApprovalRejectModalParam({
        show: true,
        okCallBack: (rejectReason) => {
          handleOnClickUpdate(rejectReason);
        },
      });
    } else {
      // 小工事基準チェック
      if (!checkMinorConstruction()) return;
      setDialog({
        type: 'confirm',
        message: `${_caption}します。よろしいですか？`,
        okCallBack: () => {
          if (_cmd == 'del') {
            handleOnClickDelete();
          } else {
            handleOnClickUpdate(false);
          }
        },
      });
    }
  };

  // ステータス取得
  const getStatus = (_mode) => {
    switch (_mode) {
      case 'approval':
        return '承認済み';
      case 'los':
        return '失注';
      case 'request':
        return '承認待ち';
      case 'cancel':
        return '作成中';
      case 'reject':
        return '承認却下';
      case 'add':
        return '作成中';
      case 'upd':
        return quoteHeader['STATUS'] == '承認待ち' ? '承認待ち' : '作成中';
      case 'minor':
        return '小工事';
      default:
        return '';
    }
  };

  // 更新処理
  const handleOnClickTempUpdate = () => {
    // 小工事基準チェック
    if (!checkMinorConstruction()) return;

    let _cmd = action[mode]['cmd'];

    // 登録とコピーの場合は2回目以降更新
    if (_cmd == 'add') {
      _cmd = tempCount == 0 ? 'add' : 'upd';
      // モードを更新した後、クリック回数を増加させる
      setTempCount(tempCount + 1);
    }

    let _quoteHeader = {
      ...quoteHeader,
      STATUS: quoteHeader.MINOR_CONSTRUCTION_FLG == 1 ? getStatus('minor') : getStatus(_cmd),
      SEIKYU_NO: quoteHeader.SEIKYU_NO ?? location?.state?.seikyuNo,
      MOTO_KEI_NO: isAddInvoice ? 1 : 0, // 追加請求の場合は元契約番号に1を設定
      MITSU_KIN: quoteTotal[0].Zeinuki,
      ZEI: quoteTotal[0].ZeiKei,
      GENKA_TOTAL: quoteTotal[0].GenkaKei,
      NEBIKI: quoteTotal[0].Nebiki,
    };

    let req = {
      client: { CLIENT_CD: client.CLIENT_CD },
      header: _quoteHeader,
      kbns: quoteKbns,
      details: quoteDetails.map((x, i) => ({
        QUOTE_MNO: i + 1,
        QUOTE_KNO: x.QUOTE_KNO,
        QUOTE_MNO_KEY: x.QUOTE_MNO_KEY ?? '',
        BASE_NO: x.BASE_NO,
        KOUJI_SYU: x.KOUJI_SYU,
        CONTENT: x.CONTENT,
        SIYOU: x.SIYOU,
        SU: x.SU,
        TANI: x.TANI,
        TANKA: x.TANKA ?? '',
        KINGAKU: x.KINGAKU,
        BIKO: x.BIKO,
        BIKO_COLOR: x.BIKO_COLOR,
        BIKO_SYANAI: x.BIKO_SYANAI,
        KOUJI_TYPE: x.KOUJI_TYPE,
        GENKA_RATE: x.GENKA_RATE ?? '',
        GENKA_TANKA: x.GENKA_TANKA ?? '',
        GENKA_KINGAKU: x.GENKA_KINGAKU,
        EDITABLE_FLG: x.EDITABLE_FLG,
        KOUJIHI_PER: x.KOUJIHI_PER,
      })),
    };
    restApi.post(`/api/quote/${_cmd}`, req, (data) => {
      quoteHeader.QUOTE_NO = data.QUOTE_NO;
      setEdited(false); // 編集中フラグを解除
      setToast({ type: 'info', message: '保存しました。' });
    });
  };

  // 更新処理
  const handleOnClickUpdate = (rejectReason = null) => {
    let _mode = rejectReason ? 'reject' : mode;

    if (quoteHeader.MINOR_CONSTRUCTION_FLG == 1) {
      _mode = 'minor';
    }

    let _quoteHeader = {
      ...quoteHeader,
      STATUS: getStatus(_mode),
      SEIKYU_NO: quoteHeader.SEIKYU_NO ?? location?.state?.seikyuNo,
      MOTO_KEI_NO: isAddInvoice ? 1 : 0, // 追加請求の場合は元契約番号に1を設定
      MITSU_KIN: quoteTotal[0].Zeinuki,
      ZEI: quoteTotal[0].ZeiKei,
      GENKA_TOTAL: quoteTotal[0].GenkaKei,
      NEBIKI: quoteTotal[0].Nebiki,
    };
    // 却下理由がある場合は却下理由を更新する
    if (rejectReason) {
      _quoteHeader.REJECT_REASON = rejectReason;
    }

    let req = {
      client: { CLIENT_CD: client.CLIENT_CD },
      header: _quoteHeader,
      kbns: quoteKbns,
      details: quoteDetails.map((x, i) => ({
        QUOTE_MNO: i + 1,
        QUOTE_KNO: x.QUOTE_KNO,
        QUOTE_MNO_KEY: x.QUOTE_MNO_KEY ?? '',
        BASE_NO: x.BASE_NO,
        KOUJI_SYU: x.KOUJI_SYU,
        CONTENT: x.CONTENT,
        SIYOU: x.SIYOU,
        SU: x.SU,
        TANI: x.TANI,
        TANKA: x.TANKA ?? '',
        KINGAKU: x.KINGAKU,
        BIKO: x.BIKO,
        BIKO_COLOR: x.BIKO_COLOR,
        BIKO_SYANAI: x.BIKO_SYANAI,
        KOUJI_TYPE: x.KOUJI_TYPE,
        GENKA_RATE: x.GENKA_RATE ?? '',
        GENKA_TANKA: x.GENKA_TANKA ?? '',
        GENKA_KINGAKU: x.GENKA_KINGAKU,
        EDITABLE_FLG: x.EDITABLE_FLG,
        KOUJIHI_PER: x.KOUJIHI_PER,
      })),
    };

    let _cmd = rejectReason ? 'upd' : action[mode]['cmd'];

    // 一時保存している場合は更新
    if (_cmd == 'add' && tempCount > 0) {
      _cmd = 'upd';
    }
    restApi.post(`/api/quote/${_cmd}`, req, (data) => {
      navigate(backPage, {
        state: {
          ...location.state,
          edited: false, // 編集中フラグを解除
          clientId: client.CLIENT_CD,
        },
      });
    });
  };

  // 削除・失注処理
  const handleOnClickDelete = () => {
    restApi.post(
      `/api/quote/${action[mode]['cmd']}`,
      {
        client: { CLIENT_CD: client.CLIENT_CD },
        header: quoteHeader,
      },
      (data) => {
        navigate(backPage, {
          state: {
            ...location.state,
            clientId: client.CLIENT_CD,
          },
        });
      }
    );
  };

  // 戻るボタン
  const handleOnClickReturn = () => {
    if (edited && !confirm('保存されていないデータは削除されますが、よろしいですか？')) {
      return;
    }
    navigate(backPage, {
      state: {
        ...location.state,
        edited: false, // 編集中フラグを解除
        clientId: client.CLIENT_CD,
      },
      replace: true, // 現在のページの履歴を置き換える
    });
  };

  // 合計グリッドの編集処理
  const cellEditEnded = (grid, args) => {
    var dataItem = grid.rows[args.row].dataItem;
    // 値引きはマイナスに
    if (dataItem['Nebiki'] > 0) {
      dataItem['Nebiki'] = dataItem['Nebiki'] * -1;
    }
    dataItem['Zeinuki'] = dataItem['ShoKei'] + dataItem['Nebiki'];
    dataItem['ZeiKei'] = calcTax(dataItem['Zeinuki']);
    dataItem['SeikyuKei'] = dataItem['Zeinuki'] + dataItem['ZeiKei'];
    dataItem['ArariKei'] = dataItem['Zeinuki'] - dataItem['GenkaKei'];
    let arariritu = dataItem['ArariKei'] / dataItem['Zeinuki'];
    dataItem['RiekiRitsu'] = !isNaN(arariritu) ? arariritu : 0;

    grid.beginUpdate();
    grid.setCellData(args.row, 2, dataItem['Nebiki'], true);
    grid.setCellData(args.row, 3, dataItem['Zeinuki'], true);
    grid.setCellData(args.row, 4, dataItem['ZeiKei'], true);
    grid.setCellData(args.row, 5, dataItem['SeikyuKei'], true);
    grid.setCellData(args.row, 7, dataItem['ArariKei'], true);
    grid.setCellData(args.row, 8, dataItem['RiekiRitsu'], true);
    grid.endUpdate();

    // 編集中フラグを立てる
    setEdited(true);
  };

  // 見積コピー処理
  const handleQuoteCopy = (quoteNo, copiedQuoteData) => {
    //在の最大の見積区分番号を取得
    const maxQuoteKno = quoteKbns.length > 0
      ? Math.max(...quoteKbns.map(k => k.QUOTE_KNO))
      : 0;

    //コピー元の工事種別と明細の見積区分番号を再採番
    let newQuoteKno = maxQuoteKno + 1;
    const knoMapping = {};

    // コピー元の工事種別ごとに新しい番号を割り当て
    const uniqueKnos = [...new Set(copiedQuoteData.details.map(d => d.QUOTE_KNO))].sort();
    uniqueKnos.forEach(oldKno => {
      knoMapping[oldKno] = newQuoteKno++;
    });

    //工事種別を追加
    const newQuoteKbns = copiedQuoteData.kbns.map(kbn => ({
      QUOTE_NO: quoteHeader.QUOTE_NO,
      QUOTE_KNO: knoMapping[kbn.QUOTE_KNO],
      KOUJI_CD: kbn.KOUJI_CD || '',
      KOUJI_SYU: kbn.KOUJI_SYU,
      KOUJI_DISPLAY_NAME: kbn.KOUJI_DISPLAY_NAME,
      SIYOU: kbn.SIYOU || '',
      SU: kbn.SU || 1,
      TANI: kbn.TANI || '式',
      TANKA: kbn.TOTAL,
      TOTAL: kbn.TOTAL,
      AREA: kbn.AREA || '',
      BIKO: kbn.BIKO || '',
      BIKO_COLOR: kbn.BIKO_COLOR || '#000000',
      GENKA_TOTAL: 0,
      REFERNCE_PRICE: kbn.REFERNCE_PRICE || 0,
    }));

    //明細を追加
    const newQuoteDetails = copiedQuoteData.details.map((detail) => ({
      QUOTE_NO: quoteHeader.QUOTE_NO,
      QUOTE_KNO: knoMapping[detail.QUOTE_KNO],
      QUOTE_MNO: 0,
      BASE_NO: detail.BASE_NO || 0,
      KOUJI_SYU: detail.KOUJI_SYU,
      CONTENT: detail.CONTENT,
      SIYOU: detail.SIYOU || '',
      SU: detail.SU || 0,
      SU_CALC_FORMULA: detail.SU_CALC_FORMULA || null,
      TANI: detail.TANI || '',
      TANKA: detail.TANKA || 0,
      TANKA_CALC_FORMULA: detail.TANKA_CALC_FORMULA || null,
      KINGAKU: detail.KINGAKU || 0,
      BIKO: detail.BIKO || '',
      BIKO_COLOR: detail.BIKO_COLOR || '#000000',
      GENKA_RATE: detail.GENKA_RATE || 0,
      GENKA_TANKA: detail.GENKA_TANKA || 0,
      GENKA_KINGAKU: detail.GENKA_KINGAKU || 0,
      BIKO_SYANAI: detail.BIKO_SYANAI || '',
      KOUJI_TYPE: detail.KOUJI_TYPE || 1,
      KOUJIHI_PER: detail.KOUJIHI_PER || 0,
      EDITABLE_FLG: detail.EDITABLE_FLG || '0',
    }));

    //既存のデータと結合
    let _quoteKbns = [...quoteKbns, ...newQuoteKbns];
    let _quoteDetails = [...quoteDetails, ...newQuoteDetails];

    //参考価格を除いた工事費を算出
    const refKnos = _quoteKbns.filter((qk) => qk.REFERNCE_PRICE == 1).map((qk) => qk.QUOTE_KNO);
    let koujihi = _quoteDetails
      .filter((x) => !refKnos.includes(x.QUOTE_KNO))
      .filter((x) => x['KOUJI_TYPE'] == 1 || x['KOUJI_TYPE'] == 2)
      .reduce((a, x) => a + toFloat(x['KINGAKU']), 0);

    //工事費パーセンテージを再計算
    _quoteDetails = _quoteDetails.map((x) => {
      if (x.KOUJI_TYPE != 3 || x.KOUJIHI_PER > 100) {
        return x;
      }
      //工事費パーセンテージの場合
      //対象の工事が参考価格だった場合はプラスする
      let targetKujihi = 0;
      if (refKnos.includes(x.QUOTE_KNO)) {
        targetKujihi = _quoteDetails
          .filter((y) => y.QUOTE_KNO == x.QUOTE_KNO)
          .filter((y) => y['KOUJI_TYPE'] == 1 || y['KOUJI_TYPE'] == 2)
          .reduce((a, y) => a + toFloat(y['KINGAKU']), 0);
      }
      const kingaku = toFloat(((koujihi + targetKujihi) * x.KOUJIHI_PER) / 100, 0);
      return {
        ...x,
        TANKA: kingaku,
        KINGAKU: kingaku,
      };
    });

    //合計金額を再計算
    _quoteKbns = _quoteKbns.map((k) => {
      const total = _quoteDetails
        .filter((d) => d.QUOTE_KNO == k.QUOTE_KNO)
        .reduce((a, x) => a + toFloat(x['KINGAKU']), 0);

      const genkaTotal = _quoteDetails
        .filter((d) => d.QUOTE_KNO == k.QUOTE_KNO)
        .reduce((a, x) => a + toFloat(x['GENKA_KINGAKU']), 0);

      return { ...k, TANKA: total, TOTAL: total, GENKA_TOTAL: genkaTotal };
    });

    //見積区分番号を昇順で並べ替え
    _quoteKbns.sort((a, b) => a.QUOTE_KNO - b.QUOTE_KNO);
    _quoteDetails.sort((a, b) => {
      if (a.QUOTE_KNO !== b.QUOTE_KNO) {
        return a.QUOTE_KNO - b.QUOTE_KNO;
      }
      return (a.QUOTE_MNO || 0) - (b.QUOTE_MNO || 0);
    });

    setQuoteKbns(_quoteKbns);
    setQuoteDetails(_quoteDetails);

    //編集中フラグを立てる
    setEdited(true);
  };

  return (
    <>
      <Card className={`m-0 ${edited ? 'edited-quote-entry' : ''}`}>
        <Card.Body>
          <Row
            onClick={() => {
              setDisplayInfo(!displayInfo);
            }}
          >
            <Col style={{ display: 'flex', columnGap: '15px', whiteSpace: 'nowrap' }}>
              <Label
                style={{ fontSize: '120%', fontWeight: 'bold', color: 'black' }}
              >{`${client.NAME_1}`}</Label>
              {mode == 'add' || mode == 'cpy' ? (
                <StatusLableComponent status={'新規'} />
              ) : (
                <StatusLableComponent
                  status={quoteHeader.STATUS}
                  rejectReason={quoteHeader.REJECT_REASON}
                  openRejectCommentModal={approvalRejectCommentModal.openModal}
                />
              )}
              {/* 編集中の場合に表示する */}
              {['add', 'upd', 'cpy'].includes(mode) && edited && (
                <Stack
                  direction="row"
                  spacing={0}
                  alignItems="center"
                  style={{ color: 'red' }}
                  sx={{
                    animation: 'blink 2.5s steps(2, start) infinite',
                    '@keyframes blink': {
                      '0%': { opacity: 1 },
                      '100%': { opacity: 0 },
                    },
                  }}
                >
                  <EditIcon />
                  <Typography>編集中</Typography>
                </Stack>
              )}
            </Col>
            <Col className="text-right">
              <div className="font-icon-detail">
                {displayInfo ? (
                  <i className="material-symbols-rounded">keyboard_control_key</i>
                ) : (
                  <i className="material-symbols-rounded">keyboard_arrow_right</i>
                )}
              </div>
            </Col>
          </Row>
          <Row className="mt-2 mb-2">
            <Col className="mr-3" md="2">
              <Form.Group>
                <label>見積書フォーマット</label>
                <SelectComponent
                  value={quoteHeader?.QUOTE_FORMAT_TYPE}
                  disabled={action[mode].readOnly}
                  onChange={handleHeaderChange('QUOTE_FORMAT_TYPE')}
                >
                  {QuoteFormatTypes.map((x, i) => (
                    <option key={i} value={x.key}>
                      {x.value}
                    </option>
                  ))}
                </SelectComponent>
              </Form.Group>
            </Col>

            {
              // 小工事またはスポットの場合、見積承認不要のチェックボックスを表示
              (constraction?.KOUJI_KBN2 === KoujiKbn2Type.MINOR_CONSTRUCTION || constraction?.KOUJI_KBN2 === KoujiKbn2Type.SPOT) && (
                <>
                  <Col className=" ml-2 mt-4" md="4">
                    <Form.Group>
                      <label
                        className="mr-2"
                        style={{ fontSize: '14pt', color: 'black' }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <input
                          className="mr-2"
                          style={{ transform: 'scale(1.5)' }}
                          type="checkbox"
                          checked={quoteHeader?.MINOR_CONSTRUCTION_FLG == 1}
                          onChange={(e) => {
                            setQuoteHeader({
                              ...quoteHeader,
                              MINOR_CONSTRUCTION_FLG: e.target.checked ? 1 : 0,
                            });
                            setEdited(true);
                          }}
                          disabled={action[mode].readOnly}
                        />
                        受注済み小工事（見積承認不要）
                      </label>
                    </Form.Group>
                  </Col>
                </>
              )
            }
          </Row>
          {displayInfo ? (
            <>
              <Row>
                <Col className="pr-1" md="3">
                  <Form.Group>
                    <label>工事名</label>
                    <TextComponent
                      placeholder=""
                      type="text"
                      value={constraction?.KOUJI_MEI}
                      disabled={true}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col className="pr-1" md="4">
                  <Form.Group>
                    <label>工事場所</label>
                    <TextComponent
                      placeholder=""
                      type="text"
                      value={`${constraction?.PREF}${constraction?.CITY}${constraction?.TOWN}${constraction?.ADDRESS}`}
                      disabled={true}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                {isAddInvoice ? (
                  <></>
                ) : (
                  <>
                    <Col className="pr-1" md="2">
                      <Form.Group>
                        <label>工期</label>
                        <TextComponent
                          type="text"
                          value={quoteHeader?.KOUKI}
                          onChange={handleHeaderChange('KOUKI')}
                          disabled={action[mode].readOnly}
                        ></TextComponent>
                      </Form.Group>
                    </Col>
                    <Col className="pr-1" md="2">
                      <Form.Group>
                        <label>有効期間</label>
                        <TextComponent
                          placeholder=""
                          type="text"
                          value={quoteHeader?.MITSU_KIGEN}
                          onChange={handleHeaderChange('MITSU_KIGEN')}
                          disabled={action[mode].readOnly}
                        ></TextComponent>
                      </Form.Group>
                    </Col>
                  </>
                )}
              </Row>
              <Row>
                <Col className="pr-1" md="3">
                  <Form.Group>
                    <label>社内呼称</label>
                    <TextComponent
                      placeholder=""
                      type="text"
                      value={quoteHeader?.SYANAI_MEI}
                      onChange={handleHeaderChange('SYANAI_MEI')}
                      disabled={action[mode].readOnly}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col className="pr-1" md="2">
                  <Form.Group>
                    <label>図面番号</label>
                    <TextComponent
                      type="text"
                      value={quoteHeader?.ZUMEN_NO}
                      onChange={handleHeaderChange('ZUMEN_NO')}
                      disabled={action[mode].readOnly}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col className="pr-1" md="2">
                  <Form.Group>
                    <label>{isAddInvoice ? '作成日' : '見積日'}</label>
                    <TextComponent
                      type="date"
                      value={quoteHeader?.MITSU_DATE}
                      onChange={handleHeaderChange('MITSU_DATE')}
                      disabled={action[mode].readOnly}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                {isAddInvoice ? (
                  <></>
                ) : (
                  <Col className="pr-1" md="2">
                    <Form.Group>
                      <label>見積責任者</label>
                      <SelectComponent
                        value={quoteHeader?.TAN_CD}
                        onChange={handleHeaderChange('TAN_CD')}
                        disabled={action[mode].readOnly}
                      >
                        <option value={''}></option>
                        {master.planer.map((x, i) => (
                          <option key={i} value={x['id']}>
                            {x['name']}
                          </option>
                        ))}
                      </SelectComponent>
                    </Form.Group>
                  </Col>
                )}

                <Col className="pr-1" md="2">
                  <Form.Group>
                    <label>値引き名称</label>
                    <SelectComponent
                      value={quoteHeader?.NEBIKI_HEADER}
                      onChange={handleHeaderChange('NEBIKI_HEADER')}
                      disabled={action[mode].readOnly}
                    >
                      <option value={'特別割引'}>特別割引</option>
                      <option value={'出精値引き'}>出精値引き</option>
                    </SelectComponent>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="pr-1" md="6" rows="3">
                  <Form.Group>
                    <div className="mb-3">
                      <label htmlFor="textArea1" className="form-label">
                        備考
                      </label>
                      <TextComponent
                        className="form-control"
                        type="textarea"
                        id="textArea1"
                        rows="2"
                        value={quoteHeader?.BIKO}
                        onChange={handleHeaderChange('BIKO')}
                        disabled={mode == 'del'}
                      ></TextComponent>
                    </div>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <div className="mb-3">
                      <label htmlFor="textArea2" className="form-label">
                        社内備考（※見積書には印刷されません）
                      </label>
                      <TextComponent
                        className="form-control"
                        type="textarea"
                        rows="2"
                        value={quoteHeader?.BIKO_SYANAI}
                        onChange={handleHeaderChange('BIKO_SYANAI')}
                        disabled={mode == 'del'}
                      ></TextComponent>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
        </Card.Body>
      </Card>
      <Card className={`m-0 ${edited ? 'edited-quote-entry' : ''}`}>
        <Card.Body>
          <Row>
            <Col>工事見積明細</Col>
            <Col className="text-right">
              {!action[mode].readOnly && (
                <>
                  <Button
                    className="btn-fill mr-2 mb-1"
                    variant="success"
                    size="sm"
                    title="見積書をコピー"
                    onClick={() => setShowCopyModal(true)}
                  >
                    見積書をコピー
                  </Button>
                  <Button
                    className="material-symbols-rounded cell-icon-sm btn-fill"
                    title="明細登録"
                    onClick={handleOnClickDetailRegist}
                  >
                    add
                  </Button>
                </>
              )}
            </Col>
          </Row>
          <Row>
            <Col
              className="pl-3 table-scroll"
              md="12"
              style={
                displayInfo ? { height: 'calc(100vh - 578px)' } : { height: 'calc(100vh - 335px)' }
              }
            >
              <FlexGrid
                allowSorting={false}
                ref={flexGrid}
                itemsSource={viewQuoteDetails}
                isReadOnly={true}
                selectionMode={'None'}
                headersVisibility={'Column'}
                initialized={initializedGrid.bind(this)}
                formatItem={formatItem}
                loadedRows={(grid) => {
                  grid.rows.forEach((ele) => {
                    ele.height = 24;
                  });
                }}
              >
                <FlexGridColumn binding="" header="名称" isReadOnly={true} width={200}>
                  <FlexGridCellTemplate
                    cellType="Cell"
                    template={(cell) =>
                      cell.item && cell.item['Group'] && !action[mode].readOnly ? (
                        <div
                          style={{ width: '500px' }}
                          onMouseEnter={() => setHoverItem(cell.item)}
                          onMouseLeave={() => setHoverItem(-1)}
                        >
                          <Button
                            className="material-symbols-rounded cell-icon-sm btn-fill"
                            variant="primary"
                            title="編集"
                            onClick={handleOnClickDetailEdit(cell.item)}
                          >
                            Edit
                          </Button>
                          <span className="text-nowrap pl-1">
                            {cell.item ? `${cell.item.CONTENT}` : ''}
                          </span>
                          {hoverItem == cell.item ? (
                            <>
                              {cell.item.QUOTE_KNO != quoteKbns.length && (
                                <Button
                                  className="material-symbols-rounded cell-icon-sm btn-fill ml-1"
                                  variant="success"
                                  title="下に移動"
                                  onClick={handleOnClickDetailMove(cell.item, 'down')}
                                >
                                  Arrow_Downward
                                </Button>
                              )}
                              {cell.item.QUOTE_KNO != 1 && (
                                <Button
                                  disabled={cell.item.QUOTE_KNO == 1}
                                  className="material-symbols-rounded cell-icon-sm btn-fill ml-1"
                                  variant="success"
                                  title="上に移動"
                                  onClick={handleOnClickDetailMove(cell.item, 'up')}
                                >
                                  Arrow_Upward
                                </Button>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      ) : (
                        <>{cell.item ? cell.item['CONTENT'] : ''}</>
                      )
                    }
                  />
                </FlexGridColumn>
                <FlexGridColumn
                  binding="SIYOU"
                  header="仕様"
                  isReadOnly={true}
                  width={200}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="SU"
                  header="数量"
                  format="n2"
                  width={60}
                  dataType="Number"
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="TANI"
                  header="単位"
                  isReadOnly={true}
                  width={45}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="KOUJIHI_PER"
                  header="％"
                  width={45}
                  dataMap={koujihiPersentMap}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="TANKA"
                  header="単価"
                  format="c0"
                  isReadOnly={true}
                  width={80}
                  dataType="Number"
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="KINGAKU"
                  header="金額"
                  format="c0"
                  width={100}
                  dataType="Number"
                ></FlexGridColumn>
                <FlexGridColumn binding="BIKO" header="備考" width={180}></FlexGridColumn>
                <FlexGridColumn
                  binding="GENKA_RATE"
                  header="掛け率"
                  format="n2"
                  width={60}
                  dataType="Number"
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="GENKA_TANKA"
                  header="原価単価"
                  format="c0"
                  isReadOnly={true}
                  width={80}
                  dataType="Number"
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="GENKA_KINGAKU"
                  header="原価合計"
                  format="c0"
                  isReadOnly={true}
                  width={100}
                  dataType="Number"
                  allowResizing={false}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding=""
                  header=""
                  format="c0"
                  isReadOnly={true}
                  width={28}
                  allowResizing={false}
                >
                  <FlexGridCellTemplate
                    cellType="Cell"
                    template={(cell) =>
                      cell.item && cell.item['EDITABLE_FLG'] == '1' ? (
                        <i
                          className="material-symbols-rounded p-1"
                          style={{ transform: 'scale(1.6)', color: 'green', background: '#DDFFDD' }}
                        >
                          Done
                        </i>
                      ) : (
                        <></>
                      )
                    }
                  />
                </FlexGridColumn>
                <FlexGridColumn
                  binding="BIKO_SYANAI"
                  header="社内備考"
                  width="*"
                  allowResizing={false}
                ></FlexGridColumn>
                <FlexGridColumn binding="" header="　" isReadOnly={true} width={28}>
                  <FlexGridCellTemplate
                    cellType="Cell"
                    template={(cell) =>
                      cell.item && cell.item['Group'] && !action[mode].readOnly ? (
                        <IconButtonCompnent
                          className="cell-icon-sm"
                          variant="danger"
                          title="削除"
                          onClick={handleOnClickDetailDelete(cell.item)}
                          disabled={!cell.item.Deletable}
                          tooltip={
                            cell.item.Deletable ? '' : '注文明細が存在するため、削除できません。'
                          }
                          icon="Clear"
                        ></IconButtonCompnent>
                      ) : (
                        <></>
                      )
                    }
                  />
                </FlexGridColumn>
              </FlexGrid>
            </Col>
          </Row>
          <Row className="pt-2">
            <Col>
              <Row>
                <Col className="d-flex align-items-end">
                  <Button
                    className="footer-button"
                    variant="secondary"
                    onClick={handleOnClickReturn}
                  >
                    戻る
                  </Button>
                </Col>
                <Col>
                  <Row className="pr-3 text-right">
                    <FlexGrid
                      itemsSource={quoteTotal}
                      selectionMode={'Cell'}
                      headersVisibility={'Column'}
                      allowSorting={false}
                      cellEditEnded={cellEditEnded}
                      pasted={cellEditEnded}
                    >
                      <FlexGridColumn
                        isReadOnly={true}
                        cssClass="cell-readonly"
                        binding="Koujihi"
                        header="工事費"
                        format="c0"
                        width={'1*'}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        isReadOnly={true}
                        cssClass="cell-readonly"
                        binding="ShoKei"
                        header="小計"
                        format="c0"
                        width={'1*'}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Nebiki"
                        isReadOnly={action[mode].readOnly}
                        header={quoteHeader?.NEBIKI_HEADER}
                        format="c0"
                        width={'1*'}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        cssClass="cell-readonly"
                        isReadOnly={true}
                        binding="Zeinuki"
                        header="税別合計"
                        format="c0"
                        width={'1*'}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        cssClass="cell-readonly"
                        isReadOnly={true}
                        binding="ZeiKei"
                        header="消費税"
                        format="c0"
                        width={90}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        cssClass="cell-readonly"
                        isReadOnly={true}
                        binding="SeikyuKei"
                        header="請求金額"
                        format="c0"
                        width={'1*'}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        cssClass="cell-readonly"
                        isReadOnly={true}
                        binding="GenkaKei"
                        header="原価合計"
                        format="c0"
                        width={'1*'}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        cssClass="cell-readonly"
                        isReadOnly={true}
                        binding="ArariKei"
                        header="粗利益額"
                        format="c0"
                        width={'1*'}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        cssClass="cell-readonly"
                        isReadOnly={true}
                        binding="RiekiRitsu"
                        header="利益率"
                        format="p1"
                        width={80}
                      ></FlexGridColumn>
                    </FlexGrid>
                  </Row>
                </Col>
                <Col className="d-flex align-items-end flex-row-reverse">
                  {mode == 'approval' ? (
                    <Button
                      variant={'danger'}
                      className="ml-2 btn-fill footer-button"
                      onClick={(e) => handleOnClickSave(e, 'reject')}
                    >
                      却下
                    </Button>
                  ) : null}
                  <Button
                    variant={action[mode]['variant']}
                    className="btn-fill footer-button"
                    onClick={handleOnClickSave}
                  >
                    {action[mode]['caption']}
                  </Button>

                  {/* add, upd, cpy の場合に「一時保存」ボタンを追加 */}
                  {['add', 'upd', 'cpy'].includes(mode) && (
                    <Button
                      variant={'primary'}
                      className="mr-2 btn-fill footer-button"
                      onClick={() => {
                        handleOnClickTempUpdate();
                      }}
                      disabled={!edited}
                    >
                      閉じずに保存
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {/* メッセージモーダル */}
      <MessageModal dialog={dialog}></MessageModal>
      {/* トーストメッセージ */}
      <ToastMessage toast={toast}></ToastMessage>
      {/* 申請却下モーダル */}
      <ApprovalRejectModal params={approvalRejectModalParam}></ApprovalRejectModal>
      {/* 見積もり基盤モーダル */}
      <QuoteBaseModal
        show={show}
        setShow={setShow}
        paramBaseQuote={paramBaseQuote}
        callbackQuoteDetaiModal={callbackQuoteDetaiModal}
      ></QuoteBaseModal>
      <QuoteCopyModal
        show={showCopyModal}
        setShow={setShowCopyModal}
        onCopy={handleQuoteCopy}
      />
    </>
  );
}

export default CustomerQuoteEntry;
